import { Address } from '../../interfaces/Address';

export default function isAddressEmpty(address: Address): boolean {
  if (!address?.appartementOrSuite &&
    !address?.appartementOrSuiteType &&
    !address?.city &&
    !address?.civicNumber &&
    !address?.country &&
    !address?.street &&
    !address?.postalCode &&
    !address?.province &&
    !address?.postOfficeBox &&
    !address?.externalPlace &&
    !address?.deliveryMethod) {
    return true;
  }
  return false;
}
